export function toAuthorSlug(author: string): string {
  return author.replace(/\./g, '').replace(/\s+/g, '-').toLocaleLowerCase()
}
